import { render, staticRenderFns } from "./ServiceInfoDesignDirection.vue?vue&type=template&id=54472b24&scoped=true&"
import script from "./ServiceInfoDesignDirection.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoDesignDirection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoDesignDirection.vue?vue&type=style&index=0&id=54472b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54472b24",
  null
  
)

export default component.exports